import ContainerFlex, { PrintableBodyWrapper } from "components/ContainerFlex";
import * as St from "./styles";
import { getItemLocalStore } from "utils/storeUtils";
import { LOCAL_STORE_CLIENTE } from "../../../../../constants";
import { hideCpf, moneyMask } from "utils/mask";
import moment from "moment";

const PrintPaymentPixVoucher = ({ data, antecipation }: any) => {
  const { cpf, nome } = getItemLocalStore(LOCAL_STORE_CLIENTE);

  const dataHora = moment(
    data?.dataPagamento ? data?.dataPagamento : data?.dataCriacao
  ).format("DD/MM/YYYY HH:mm");

  return (
    <PrintableBodyWrapper>
      <St.TitleFaturaTextValue>
        {antecipation
          ? "Comprovante de Pagamento da Antecipação TeuCard pelo TOTEM"
          : "Comprovante de Pagamento da Fatura TeuCard pelo TOTEM"}
      </St.TitleFaturaTextValue>
      <ContainerFlex row>
        <ContainerFlex>
          <St.SpanTextTitleBold>Cliente Origem: </St.SpanTextTitleBold>
          <St.SpanTextTitle>{nome}</St.SpanTextTitle>
        </ContainerFlex>
        <ContainerFlex end align="flex-end">
          <St.SpanTextTitleBold>CPF:</St.SpanTextTitleBold>
          <St.SpanTextTitle>{hideCpf(cpf)}</St.SpanTextTitle>
        </ContainerFlex>
      </ContainerFlex>
      <St.Dividers />

      <St.TitleFaturaTextValue>Resumo do pagamento</St.TitleFaturaTextValue>
      <ContainerFlex row>
        <St.SpanTextTitle>Data de pagamento:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>{dataHora}</St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>Valor informado:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>{moneyMask(Number(data?.valor))}</St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>Tipo de transação:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>{data?.tipo || "PIX"}</St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>
      {!antecipation && (
        <ContainerFlex row>
          <St.SpanTextTitle>Loja: </St.SpanTextTitle>
          <ContainerFlex end align="flex-end">
            <St.SpanTextTitle>{data?.loja?.nome}</St.SpanTextTitle>
          </ContainerFlex>
        </ContainerFlex>
      )}

      <ContainerFlex row>
        <ContainerFlex>
          <St.SpanTextTitle>Código de autenticação: </St.SpanTextTitle>
        </ContainerFlex>
        <ContainerFlex end align="flex-end">
          <St.SpanTextTitle>{data?.txId}</St.SpanTextTitle>
        </ContainerFlex>
      </ContainerFlex>

      <St.Dividers />
    </PrintableBodyWrapper>
  );
};

export default PrintPaymentPixVoucher;
